import { type FC } from 'react';

import { useGetWorkflowRuleDefinitionsQuery } from '@zen/Workflows/WorkflowRules/graphql';
import WorkflowRulesTable from '@zen/Workflows/WorkflowRules/WorkflowRulesTable';

import { useGetAccountBusinessUnitsQuery } from '../graphql';
import type { SOP } from './types';

interface Props {
  accountId: string;
  canCreateSOP?: boolean;
}

const SOPs: FC<Props> = ({ accountId, canCreateSOP }) => {
  const { data, loading: ruleDefinitionsLoading } = useGetWorkflowRuleDefinitionsQuery({
    variables: { filter: { isSop: true } }
  });

  const { data: businessUnitsData } = useGetAccountBusinessUnitsQuery({
    variables: { accountId, first: 20 },
    skip: ruleDefinitionsLoading
  });

  const businessUnitIds: string[] = (businessUnitsData?.accountBusinessUnits?.nodes || []).map(
    (businessUnit) => businessUnit?.id || ''
  );
  const accountHasBusinessUnits: boolean = businessUnitIds.length > 0;
  const accountsToQuery: string[] = accountHasBusinessUnits ? businessUnitIds : [accountId];

  const sops: SOP[] = (data?.workflowRuleDefinitions ?? [])
    .filter((item): item is NonNullable<typeof item> => item != null)
    .map(({ id, ruleInputFields, ruleName, ruleOutputFields }) => ({ id, ruleInputFields, ruleName, ruleOutputFields }));

  return (
    <div className="flex flex-col gap-4" data-testid="sops">
      {businessUnitsData &&
        sops.map?.((sop) => (
          <WorkflowRulesTable
            key={sop.id}
            accountIds={accountsToQuery}
            canCreateSOP={canCreateSOP}
            hideAccountsColumn={!accountHasBusinessUnits}
            ruleInputFields={sop.ruleInputFields}
            ruleOutputFields={sop.ruleOutputFields}
            workflowRuleDefinitionId={sop.id}
            workflowRuleDefinitionName={sop.ruleName}
          />
        ))}
    </div>
  );
};

export default SOPs;
